<!-- 规则-->
<template>
  <div class="rules">
    <van-popup v-model="showPop">
      <img src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/rulebg.png" alt="">
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      showPop: false,
    };
  },
  props:{},
  computed: {},
  watch: {},
  methods: {
  

  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.rules {
  ::v-deep{
    .van-popup {
    background-color: transparent !important;
  }
  .van-popup--center{
      top:47%;
    }
  }
  img{
    display: block;
    width:614px;
    height: 872px;
    margin:0 auto;
  }
}

</style>
